import React from 'react';
import { CalendarIcon } from 'components/common/icons';
import {
  AdminSelect,
  BrandSelect,
  Col,
  DatePicker,
  FilterDrawer,
  Form,
  FormInstance,
  Row,
  Select,
  SupplierSelect,
} from 'components';
import { useFilters } from './useFilters';
import { PurchaseOrderStatusOptions } from 'models/PurchaseOrder';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;

  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="brandId" label={'Brand'}>
              <BrandSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="supplierId" label={'Supplier'}>
              <SupplierSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="assignedTo" label={'Assigned To'}>
              <AdminSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdBy" label={'Created By'}>
              <AdminSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdDate" label={'Created Date'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="deliveryDeadline" label={'Delivery Deadline'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastModifiedDate" label={'Last Updated'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="status" label={'Status'}>
              <Select options={PurchaseOrderStatusOptions} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
